import React from 'react';

import { Button, Modal } from '@suntex.fim/ui';

interface DeleteMessageModalProps {
  isOpen: boolean;
  title: string;
  onOk: () => void;
  onCancel: () => void;
  content: React.ReactNode;
  okButtonText?: string;
  cancelButtonText?: string;
  className?: string;
}

export function DeleteMessageModal({
  isOpen,
  title,
  onOk,
  onCancel,
  content,
  okButtonText = 'Delete',
  cancelButtonText = 'Cancel',
  className = 'dialog',
}: DeleteMessageModalProps) {
  return (
    <Modal
      centered
      title={title}
      open={isOpen}
      onOk={onOk}
      onCancel={onCancel}
      className={className}
      closable={false}
      footer={[
        <>
          <Button
            shape="round"
            intent="secondary"
            key="cancel"
            onClick={onCancel}
          >
            {cancelButtonText}
          </Button>
          <Button shape="round" intent="danger" key="submit" onClick={onOk}>
            {okButtonText}
          </Button>
        </>,
      ]}
    >
      {content}
    </Modal>
  );
}
